
export default class User {
    id;
    username;
    first_name;
    last_name;
    email;
    phone;
    clearance;

    constructor(dict) {
        this.id = dict["id"];
        this.username = dict["username"];
        this.first_name = dict["first_name"];
        this.last_name = dict["last_name"];
        this.email = dict["email"];
        this.phone = dict["phone"];
        this.clearance = dict["clearance"];
    }

    toDict() {
        return {
            //"id" : this.id,
            //"username" : this.username,
            "first_name" : this.first_name,
            "last_name" : this.last_name,
            "email" : this.email,
            "phone" : this.phone,
            "clearance" : this.clearance,
        };
    }

    getFullName() {
        return this.first_name + " " + this.last_name
    }

    getClearanceString() {
        switch (this.clearance) {
            case 0:
                return "text.standard"
            case 1:
                return "text.family";
            case 2:
                return "text.familyplus";
            default:
                return "text.admin";
        }
    }

}